/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TSaveSurveyModel = IModel<ISaveSurveyRequest, TSaveSurveyResponse>;

export interface ISaveSurveyRequest {
  /** Ответы пользователя **/
  answers: EAnswers[];
  /** Комментарий **/
  comment?: string | null;
  /** Почта **/
  email?: string | null;
  /** ID объявления на котором заполнен опрос **/
  offerId: number;
  /** Тип страницы на которой пользователь проходил опрос **/
  pageType: EPageType;
  /** Тип оплаты **/
  paymentType?: EPaymentType | null;
  /** Телефон **/
  phone?: string | null;
  /** Тип пользователя **/
  userType?: EUserType | null;
}

export type TSaveSurveyResponse = ISaveSurveyResponse200 | ISaveSurveyResponse400;

export interface ISaveSurveyResponse200 extends IModelResponse<ISaveSurveyResponse> {
  statusCode: 200;
}

export interface ISaveSurveyResponse400 extends IModelResponse<ISaveSurveyResponseError> {
  statusCode: 400;
}

export interface ISaveSurveyResponse {}

export interface ISaveSurveyResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISaveSurveyResponse | ISaveSurveyResponseError;

export enum EAnswers {
  /** Размер средних чеков в окружении по разным типам торговых точек (аптеки, магазины и тп) **/
  AverageCheck = 'averageCheck',
  /** Текущие арендаторы, ставки и условия аренды **/
  CurrentArendators = 'currentArendators',
  /** Человекопоток людей в районе вокруг объекта **/
  FootTraffic = 'footTraffic',
  /** Инфраструктура объекта: парковочные места, столовая, банкомат и тп **/
  Infrastructure = 'infrastructure',
  /** Контактная информация владельца **/
  OwnerContacts = 'ownerContacts',
  /** Планы этажей и занятость и вакантность по этажам **/
  Plans = 'plans',
  /** Точки интереса рядом (магазины, автосервисы и тп) **/
  PointsOfInterest = 'pointsOfInterest',
  /** Технические характеристики объекта: с/у, электричество, вентиляция и тп **/
  TechnicalCharacteristics = 'technicalCharacteristics',
  /** Транспортные узлы (автобусы, метро, МЦК...) и удаленность до них **/
  Transport = 'transport',
  /** Профилирование людей, которые бывают в окрестностях: соцдем, доход, интересы **/
  VisitorProfile = 'visitorProfile',
}

export enum EPageType {
  /** Карточка **/
  Card = 'card',
  /** Листинг **/
  Listing = 'listing',
}

export enum EPaymentType {
  /** Один отчет **/
  OneTimePayment = 'oneTimePayment',
  /** Подписка **/
  Subscription = 'subscription',
}

export enum EUserType {
  /** Агент **/
  Agent = 'agent',
  /** Покупатель **/
  Buyer = 'buyer',
  /** Представитель управляющей компании **/
  ManagementCompany = 'managementCompany',
  /** Другое **/
  Other = 'other',
  /** Владелец **/
  Owner = 'owner',
  /** Арендатор **/
  Tenant = 'tenant',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISaveSurveyResponse): TResponse200;
  400(response: ISaveSurveyResponseError): TResponse400;
}
